<template>
  <div class="inverterUl">
    <div class="inverterDetails">
      <h4>{{ inverterData.name }}</h4>
      <ul>
        <li v-for="(v, i) in inverterData.left" :key="i">
          <p>{{ v.name }}</p>
          <p>
            {{
              v.name == "接入时间"
                ? v.value
                  ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.value))
                  : "-"
                : v.value
            }}
          </p>
          <p>{{ v.unit }}</p>
        </li>
      </ul>
    </div>
    <div class="inverterCenter">
      <div class="dataShow">
        <i class="el-icon-s-promotion"></i>
        <p>累计发电</p>
        <p>
          {{
            dataList.length
              ? dataList.find((v) => {
                  return v.name == "累计发电";
                }).value
              : ""
          }}kw·h
        </p>
      </div>
      <div class="chartsBox">
        <div class="stateBox">
          <el-tag
            :type="
              dataList.length
                ? dataList.find((v) => {
                    return v.name == '状态';
                  }).value
                  ? 'success'
                  : 'info'
                : ''
            "
            style="padding: 0 30px; border-radius: 20px"
            >{{
              dataList.length
                ? dataList.find((v) => {
                    return v.name == "状态";
                  }).value
                  ? "在线中"
                  : "离线中"
                : ""
            }}</el-tag
          >
        </div>
        <div class="charts">
          <InverterCharts :chartsData="chartsData" />
        </div>
        <div class="explain">
          <p>
            最后刷新时间:{{
              dataList.length
                ? dataList.find((v) => {
                    return v.name == "最后刷新时间";
                  }).value
                  ? dateFtt(
                      "yyyy-MM-dd hh:mm:ss",
                      new Date(
                        dataList.find((v) => {
                          return v.name == "最后刷新时间";
                        }).value
                      )
                    )
                  : "-"
                : ""
            }}
          </p>
        </div>
      </div>
      <div class="dataShow">
        <i class="el-icon-s-data"></i>
        <p>累计发电小时</p>
        <p>
          {{
            dataList.length
              ? dataList.find((v) => {
                  return v.name == "累计发电小时";
                }).value
              : ""
          }}{{
            dataList.length
              ? dataList.find((v) => {
                  return v.name == "累计发电小时";
                }).unit
              : ""
          }}
        </p>
      </div>
    </div>
    <div class="inverterDetails">
      <h4></h4>
      <ul>
        <li v-for="(v, i) in inverterData.right" :key="i">
          <p>{{ v.name }}</p>
          <p>{{ v.value }}</p>
          <p>{{ v.unit }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
import InverterCharts from "@/components/zixitong/photovoltaicSystem/InverterCharts.vue";
export default {
  props: ["inverterData"],
  components: {
    InverterCharts,
  },
  watch: {
    inverterData: {
      handler(newvalue, oldvalue) {
        this.dataList = newvalue.middle;
        this.getChartsData();
      },
      deep: true,
    },
  },
  data() {
    return {
      chartsData: null,
      dataList: [],
    };
  },
  methods: {
    dateFtt,
    getChartsData() {
      this.chartsData = this.inverterData.middle.find((v) => {
        return v.name == "发电量";
      }).value;
    },
  },
};
</script>

<style lang="scss" scoped>
.inverterUl {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  @include setFlexBetween;
  .inverterDetails {
    width: 28%;
    height: 100%;
    h4 {
      line-height: 40px;
      height: 40px;
      font-size: 16px;
    }
    ul {
      li {
        border-bottom: 1px solid #ebeef5;
        font-size: 12px;
        @include setFlexCenter;
        padding: 5px 0;
        p:nth-child(1) {
          font-weight: bold;
          color: #909399;
          width: 35%;
        }
        p:nth-child(2) {
          width: 50%;
        }
        p:nth-child(3) {
          width: 12%;
          text-align: right;
        }
      }
    }
  }
  .inverterCenter {
    width: 43%;
    height: 100%;
    @include setFlexAround;
    align-items: flex-end;

    .dataShow {
      width: 25%;
      height: 50%;
      @include setFlexColumn;
      align-items: center;
      justify-content: center;
      i {
        font-size: 40px;
        // color: #5d70e9;
        color: #28cccb;
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
    .chartsBox {
      width: 50%;
      height: 100%;
      @include setFlexColumn;
      .stateBox {
        width: 100%;
        height: 20%;
        @include setFlexCenter;
      }
      .charts {
        width: 100%;
        height: 70%;
      }
      .explain {
        width: 100%;
        height: 10%;
        @include setFlexCenter;
        p {
          font-size: 12px;
        }
      }
    }
  }
}
</style>